import { Paper } from '@material-ui/core';
import React from 'react';
import './CreateRoom.css';
import VideoCallIcon from '@material-ui/icons/VideoCall';

const CreateRoom = ({user}) => {
    return (
        <Paper className='room mt-4' elevation={1}>
           <div className="iconRoom d-flex">               
                <VideoCallIcon style={{fontSize: '30px'}}/> <h4>Create Room</h4>
           </div>
        </Paper>
    ); 
}; 
 
export default CreateRoom;  